// This one has not been tested yet so it may need to be tweaked before it's a complete replacement for the spinner in
// the old version of the Sub-Nav.
export default function SpinnerDirective() {
  return {
    scope: {
      active: '=',
      show: '='
    },
    restrict: 'E',
    transclude: true,
    constructor: ($scope, $element) => {
      'ngInject';

      if ($scope.active) {
        $element.addClass('active');
      }
    },
    template: `<span class="spinner" ng-if="show()" ng-transclude></span>`
  };
}
